import { Col, Row, Tabs, Typography } from "antd";
import { data } from "./data";

const OurProductsSection = () => {
  return (
    <section className="our-product-section   section-margin-top">
      <div className="container">
        <Typography.Title level={2} className="m-0 ">
          Our Products
        </Typography.Title>
      </div>
      <div>
        <Tabs
          className="product-tabs container"
          type="card"
          items={data.map((tab, i) => {
            const id = String(i + 1);
            return {
              label: tab.title,
              key: id,
              children: <ProductTab {...tab} />,
            };
          })}
        />
      </div>
    </section>
  );
};

export default OurProductsSection;

const ProductTab = ({ images, heroText, vehicleTypes }) => (
  <div className="product-tabs-tab">
    <Typography.Paragraph className="hero-text">
      {heroText}
    </Typography.Paragraph>
    <div className="vehicle-types">
      <Typography.Title className="m-0" level={5}>
        Vehicle Types:
      </Typography.Title>
      <Typography.Text className="m-0 text-primary-color">
        {vehicleTypes.join(", ")}
      </Typography.Text>
    </div>

    <Row gutter={[0, 30]} className="product-images">
      {images.map((image, index) => (
        <Col
          xs={24}
          sm={8}
          md={8}
          xl={6}
          xxl={4}
          key={index}
          className="center-on-small-screen"
        >
          <img src={image} alt={index} />
        </Col>
      ))}
    </Row>
  </div>
);
